<template>
    <div class="wrapper">
      <div class="content-container">
        <div class="stingy-card">
    <div class="tradingview-widget-container">
      <div id="tradingview-widget"></div>
    </div></div></div></div>
  </template>
  
  <script>
  import { onMounted, reactive } from 'vue';
  
  export default {
    setup() {
      const widgetConfig = reactive({
        colorTheme: "light",
        dateRange: "12M",
        showChart: true,
        locale: "en",
        largeChartUrl: "",
        isTransparent: false,
        showSymbolLogo: true,
        showFloatingTooltip: true,
        width: "400",
        height: "660",
        plotLineColorGrowing: "rgba(53, 28, 117, 1)",
        plotLineColorFalling: "rgba(142, 124, 195, 1)",
        gridLineColor: "rgba(240, 243, 250, 0)",
        scaleFontColor: "rgba(0, 0, 0, 1)",
        belowLineFillColorGrowing: "rgba(180, 167, 214, 0.12)",
        belowLineFillColorFalling: "rgba(142, 124, 195, 0.12)",
        belowLineFillColorGrowingBottom: "rgba(41, 98, 255, 0)",
        belowLineFillColorFallingBottom: "rgba(41, 98, 255, 0)",
        symbolActiveColor: "rgba(53, 28, 117, 0.12)",
        tabs: [
          {
            title: "Indices",
            symbols: [
              { s: "FOREXCOM:SPXUSD", d: "S&P 500" },
              { s: "TSX:TSX", d: "S&P/TSX 60" },
              { s: "FOREXCOM:NSXUSD", d: "Nasdaq 100" },
              { s: "FOREXCOM:DJI", d: "Dow Jones Industrial Avg" },
             
            ],
            originalTitle: "Indices"
          },
          {
            title: "Stocks",
            symbols: [
              { s: "NASDAQ:AAPL", d: "Apple Inc." },
              { s: "NASDAQ:TSLA", d: "Tesla Inc." },
              { s: "NASDAQ:NVDA", d: "Nvidia" },
              { s: "NASDAQ:MSFT", d: "Microsoft" },
              { s: "NYSE:PLTR", d: "Palantir Technologies" },
              { s: "NYSE:BA", d: "Boeing" },
              { s: "NYSE:SHOP", d: "Shopify" }
            ]
          },
          {
            title: "Futures",
            symbols: [
              { s: "CBOE:VX1!", d: "CBOE Volatility Index" },
              { s: "COMEX:GC1!", d: "Gold" },
              { s: "NYMEX:CL1!", d: "WTI Crude Oil" },
              { s: "NYMEX:NG1!", d: "Nat Gas" },
              { s: "CME:BTC1!", d: "Bitcoin Futures" },
             
            ],
            originalTitle: "Futures"
          },
        
          {
            title: "Bonds",
            symbols: [
              { s: "CBOT:ZB1!", d: "T-Bond" },
              { s: "CBOT:UB1!", d: "Ultra T-Bond" },
              { s: "ECONOMICS:CAPOP", d: "Population" },
              { s: "ECONOMICS:CAUR", d: "CAD Unemployment Rate" },
              { s: "ECONOMICS:CABLR", d: "CAD Bank Lending Rate" }
            ],
            originalTitle: "Bonds"
          },
          {
            title: "FX Rates",
            symbols: [
              { s: "FX:USDCAD", d: "USD to CAD" },
              { s: "FX:EURUSD", d: "EUR to USD" },
              { s: "FX:GBPUSD", d: "GBP to USD" },
              { s: "FX:USDJPY", d: "USD to JPY" },
              { s: "FX:USDCHF", d: "USD to CHF" },
              { s: "FX:AUDUSD", d: "AUD to USD" },
             
            ],
            originalTitle: "Forex"
          },
         
        ]
      });
  
      onMounted(() => {
        const script = document.createElement('script');
        script.src = 'https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js';
        script.async = true;
        script.innerHTML = JSON.stringify(widgetConfig);
  
        document.getElementById('tradingview-widget').appendChild(script);
      });
  
      return {
        widgetConfig,
      };
    },
  };
  </script>
  
  <style scoped>
  .tradingview-widget-container {
    width: 100%; /* Responsive width */
    min-height: 660px; /* Minimum height for visibility */
    display: flex;
    justify-content: center; /* Center the widget horizontally */
  }
  
  .wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  }
  
  .content-container {
  background-color: #4A148C ;  /* Light orange color */
  color: black;
  padding: 20px;
  border-radius: 20px;  /* Adjust this value to your preference */
  overflow: hidden; 
  }
  .stingy-card {
  flex: 1;  /* Take up equal width as the iframe */
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background-color: white
  }
  
  .stylish-links {
  background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(240,240,240,1) 100%);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0,0,0,0.1);
  }
  
  .stylish-links h3 {
  color: #333;
  font-size: 1.4em;
  margin-bottom: 15px;
  }
  
  .stylish-links ul {
  list-style: none;
  padding: 0;
  }
  
  .stylish-links ul li {
  background-color: #fff;
  margin: 10px 0;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  }
  
  .stylish-links ul li a {
  color: black;
  text-decoration: none;
  font-weight: bold;
  }
  
  .stylish-links ul li:hover {
  background-color: #4A148C;
  }
  
  .stylish-links ul li:hover a {
  color: #fff;
  }
  </style>
  